<ion-app>
  <ion-menu side="start"
            type="overlay"
            menu-id="mappage"
            content-id="main-router-outlet"
            disabled="true"
            swipe-gesture="false">

    <ion-content id="mappage-menu">
      <div id="mappage-menu-logo">
        <ion-menu-toggle>
          <div id="menu-logo" routerLink="/home">
            <img src="/assets/imgs/lem-logo.png" />
          </div>
        </ion-menu-toggle>

        <div id="menu-username">
          <ion-icon name="contact"></ion-icon>
          <span [textContent]="this.username"></span>
        </div>
      </div>

      <app-language-select></app-language-select>

      <ion-list id="menu-options" lines="none">
        <ion-item-group *ngIf="!resourcesShown">
          <ion-item (click)="showResources()" button="true">
            <ion-label><lem-lang key="menu.resources">Resources</lem-lang></ion-label>
          </ion-item>
          <ion-item (click)="go('reset-map')" button="true">
            <ion-label><lem-lang key="menu.resetMap">{{ 'Reset Map To...' | langService | async }}</lem-lang></ion-label>
          </ion-item>
          <!-- <ion-item (click)="go('tutorial')" button="true">
               <ion-label><lem-lang key="menu.tutorial">Tutorial</lem-lang></ion-label>
               </ion-item> -->
        </ion-item-group>

        <ion-item-group *ngIf="resourcesShown">
          <ion-item (click)="hideResources()" button="true" id="resources-back-button">
            <ion-label slot="end">
              <ion-icon name="arrow-back"></ion-icon>
              <span><lem-lang key="menu.back">Back</lem-lang></span>
            </ion-label>
          </ion-item>
          <ion-item (click)="go('lucs-info')" button="true">
            <ion-label><lem-lang key="menu.lucsInfo">Land-Use Codes</lem-lang></ion-label>
          </ion-item>
          <ion-item (click)="go('indicators-info')" button="true">
            <ion-label><lem-lang key="menu.indicators">Indicators</lem-lang></ion-label>
          </ion-item>
          <ion-item (click)="go('stakeholders-info')" button="true">
            <ion-label><lem-lang key="menu.stakeholders">Stakeholders</lem-lang></ion-label>
          </ion-item>
        </ion-item-group>

        <ion-item-group>
          <ion-item-divider></ion-item-divider>
          <ion-menu-toggle>
            <ion-item button="true" routerLink="/home">
              <ion-label><lem-lang key="menu.home">Home</lem-lang></ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle>
            <ion-item button="true" routerLink="/map/create">
              <ion-label><lem-lang key="menu.create">Create</lem-lang></ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle>
            <ion-item button="true" routerLink="/maps">
              <ion-label><lem-lang key="menu.maps">Maps</lem-lang></ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-item (click)="signout()" button="true" class="logout-button">
            <ion-label><lem-lang key="menu.logout">Log out</lem-lang></ion-label>
          </ion-item>
        </ion-item-group>
      </ion-list>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main-router-outlet"></ion-router-outlet>

  <app-loading *ngIf="loading"></app-loading>
</ion-app>
